import { IntlShape } from 'react-intl'

/**
 * Formato de los números de la pantalla, en un solo lugar: la cantidad siempre con separador de miles ("6.036"; la
 * locale `es` no agrupa los números de 4 cifras si no se le pide), los minutos con un decimal y los porcentajes
 * (que el backend manda ya calculados, en %) con un decimal.
 */

/** Celda o indicador sin dato. */
export const NO_VALUE = '—'

export function formatCount(intl: IntlShape, value: number): string {
  return intl.formatNumber(value, { useGrouping: 'always', maximumFractionDigits: 0 })
}

/** "38,2 min", o "—" si no hay dato. */
export function formatMinutes(intl: IntlShape, value: number | null | undefined): string {
  if (value === null || value === undefined) return NO_VALUE
  return intl.formatMessage(
    { id: 'UrgencySummaryMinutes' },
    { value: intl.formatNumber(value, { useGrouping: 'always', minimumFractionDigits: 1, maximumFractionDigits: 1 }) },
  )
}

/** `percent` ya está en % (5,8 = 5,8 %): "5,8 %", o "—" si no hay dato. */
export function formatPercent(intl: IntlShape, percent: number | null | undefined): string {
  if (percent === null || percent === undefined) return NO_VALUE
  return `${intl.formatNumber(percent, { useGrouping: 'always', minimumFractionDigits: 0, maximumFractionDigits: 1 })} %`
}
